<template>
  <div class="s-header">
    <!-- BEGIN: Левая часть хидера -->
    <div class="s-header__left-part">
      <svg class="s-header__logo" width="366" height="28" viewBox="0 0 366 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.15928 17.1502L5.62515 19.5302V27.2302H0V0.490234H5.62515V10.7102L7.08623 7.70023L10.9581 0.490234H17.4599L10.3737 12.1802L18.6287 27.3002H12.2731L7.15928 17.1502Z" fill="url(#paint0_linear)"/>
        <path d="M28.7109 0.490234H34.4091V27.3002H28.7109V0.490234Z" fill="url(#paint1_linear)"/>
        <path d="M78.0215 0.490234H85.6921C91.3173 0.490234 94.6047 3.78023 94.6047 9.38023V18.2002C94.6047 23.8702 91.3173 27.3002 85.7652 27.3002H78.0215V0.490234ZM85.7652 22.1202C87.8107 22.1202 88.9065 20.7902 88.9065 18.2002V9.38023C88.9065 6.93023 87.8107 5.67023 85.7652 5.67023H83.7197V22.1202H85.7652Z" fill="url(#paint2_linear)"/>
        <path d="M59.5406 0.490234V15.2602L52.9657 0.490234H47.6328L59.5406 27.3002H64.8735H65.0927V0.490234H59.5406Z" fill="url(#paint3_linear)"/>
        <path d="M52.965 12.7402H47.3398V27.3002H52.965V12.7402Z" fill="url(#paint4_linear)"/>
        <path d="M128.721 19.11V8.75C128.721 3.08 131.935 0 137.414 0C143.039 0 146.108 3.08 146.327 8.75H140.628C140.482 6.3 139.533 5.25 137.341 5.25C135.588 5.25 134.638 6.3 134.638 8.68V19.11C134.638 21.42 135.588 22.47 137.341 22.47C139.533 22.47 140.555 21.49 140.702 19.11H146.4C146.254 24.71 143.039 27.79 137.341 27.79C131.935 27.79 128.721 24.78 128.721 19.11Z" fill="url(#paint5_linear)"/>
        <path d="M174.818 0.55957V27.2996H169.12V16.4496H163.349V27.2996H157.65V0.55957H163.349V11.2696H169.12V0.55957H174.818Z" fill="url(#paint6_linear)"/>
        <path d="M198.049 22.8902H192.132L191.182 27.3002H185.338L192.059 0.490234H198.122L204.843 27.3002H198.999L198.049 22.8902ZM196.953 17.7102L196.296 14.6302C195.931 12.7402 195.492 9.45023 195.2 7.28023H195.054C194.762 9.45023 194.324 12.7402 193.958 14.6302L193.301 17.7102H196.953Z" fill="url(#paint7_linear)"/>
        <path d="M229.389 22.1196V27.2996H215.436V0.55957H221.134V22.1896H229.389V22.1196Z" fill="url(#paint8_linear)"/>
        <path d="M254.08 22.1196V27.2996H240.127V0.55957H245.825V22.1896H254.08V22.1196Z" fill="url(#paint9_linear)"/>
        <path d="M279.576 22.1196V27.2996H264.746V0.55957H279.138V5.73957H270.371V11.2696H278.334V16.2396H270.371V22.1896H279.576V22.1196Z" fill="url(#paint10_linear)"/>
        <path d="M321.363 19.1103V8.75031C321.363 3.15031 324.651 0.0703125 330.203 0.0703125C335.609 0.0703125 338.531 3.08031 338.75 8.75031H333.125C332.979 6.37031 332.175 5.32031 330.276 5.32031C328.376 5.32031 327.354 6.30031 327.354 8.75031V19.1803C327.354 21.5603 328.376 22.6103 330.349 22.6103C332.394 22.6103 333.417 21.6303 333.417 19.1803V17.2903H330.057V12.4603H338.969V19.1803C338.823 24.7803 335.682 27.8603 330.203 27.8603C324.651 27.7903 321.363 24.7803 321.363 19.1103Z" fill="url(#paint11_linear)"/>
        <path d="M365.342 22.1196V27.2996H350.512V0.55957H364.903V5.73957H356.137V11.2696H364.1V16.2396H356.137V22.1896H365.342V22.1196Z" fill="url(#paint12_linear)"/>
        <path d="M303.685 0.55957V15.2596L297.11 0.55957H291.777L303.685 27.2996H309.018H309.237V0.55957H303.685Z" fill="url(#paint13_linear)"/>
        <path d="M297.037 12.7393H291.412V27.2993H297.037V12.7393Z" fill="url(#paint14_linear)"/>
        <path d="M116.74 6.99958C112.941 5.80958 111.626 10.5696 111.626 10.5696C111.626 10.5696 110.311 5.80958 106.512 6.99958C104.394 7.69958 103.955 9.86958 104.394 11.9696C104.759 13.7196 105.782 15.3296 106.512 16.2396C107.681 17.7096 109.873 19.7396 111.626 20.9996C113.379 19.7396 115.571 17.7096 116.74 16.2396C117.47 15.3296 118.493 13.7196 118.858 11.9696C119.297 9.86958 118.858 7.69958 116.74 6.99958Z" fill="#EF3B4B"/>
        <defs>
        <linearGradient id="paint0_linear" x1="-0.566971" y1="13.8901" x2="94.5092" y2="13.8901" gradientUnits="userSpaceOnUse">
        <stop stop-color="#43459C"/>
        <stop offset="1" stop-color="#EF3B4B"/>
        </linearGradient>
        <linearGradient id="paint1_linear" x1="-0.566206" y1="13.8901" x2="94.5099" y2="13.8901" gradientUnits="userSpaceOnUse">
        <stop stop-color="#43459C"/>
        <stop offset="1" stop-color="#EF3B4B"/>
        </linearGradient>
        <linearGradient id="paint2_linear" x1="-0.566989" y1="13.8901" x2="94.5091" y2="13.8901" gradientUnits="userSpaceOnUse">
        <stop stop-color="#43459C"/>
        <stop offset="1" stop-color="#EF3B4B"/>
        </linearGradient>
        <linearGradient id="paint3_linear" x1="-101.791" y1="13.89" x2="195.039" y2="13.89" gradientUnits="userSpaceOnUse">
        <stop stop-color="#43459C"/>
        <stop offset="1" stop-color="#EF3B4B"/>
        </linearGradient>
        <linearGradient id="paint4_linear" x1="-0.566259" y1="19.9942" x2="94.5102" y2="19.9942" gradientUnits="userSpaceOnUse">
        <stop stop-color="#43459C"/>
        <stop offset="1" stop-color="#EF3B4B"/>
        </linearGradient>
        <linearGradient id="paint5_linear" x1="362.773" y1="13.8898" x2="128.298" y2="13.8898" gradientUnits="userSpaceOnUse">
        <stop stop-color="#43459C"/>
        <stop offset="0.4083" stop-color="#8F437C"/>
        <stop offset="1" stop-color="#EF3B4B"/>
        </linearGradient>
        <linearGradient id="paint6_linear" x1="362.773" y1="13.9276" x2="128.298" y2="13.9276" gradientUnits="userSpaceOnUse">
        <stop stop-color="#43459C"/>
        <stop offset="0.4083" stop-color="#8F437C"/>
        <stop offset="1" stop-color="#EF3B4B"/>
        </linearGradient>
        <linearGradient id="paint7_linear" x1="362.773" y1="13.9283" x2="128.298" y2="13.9283" gradientUnits="userSpaceOnUse">
        <stop stop-color="#43459C"/>
        <stop offset="0.4083" stop-color="#8F437C"/>
        <stop offset="1" stop-color="#EF3B4B"/>
        </linearGradient>
        <linearGradient id="paint8_linear" x1="362.773" y1="13.9276" x2="128.297" y2="13.9276" gradientUnits="userSpaceOnUse">
        <stop stop-color="#43459C"/>
        <stop offset="0.4083" stop-color="#8F437C"/>
        <stop offset="1" stop-color="#EF3B4B"/>
        </linearGradient>
        <linearGradient id="paint9_linear" x1="362.772" y1="13.9276" x2="128.297" y2="13.9276" gradientUnits="userSpaceOnUse">
        <stop stop-color="#43459C"/>
        <stop offset="0.4083" stop-color="#8F437C"/>
        <stop offset="1" stop-color="#EF3B4B"/>
        </linearGradient>
        <linearGradient id="paint10_linear" x1="362.772" y1="13.9276" x2="128.297" y2="13.9276" gradientUnits="userSpaceOnUse">
        <stop stop-color="#43459C"/>
        <stop offset="0.4083" stop-color="#8F437C"/>
        <stop offset="1" stop-color="#EF3B4B"/>
        </linearGradient>
        <linearGradient id="paint11_linear" x1="362.772" y1="13.9284" x2="128.297" y2="13.9284" gradientUnits="userSpaceOnUse">
        <stop stop-color="#43459C"/>
        <stop offset="0.4083" stop-color="#8F437C"/>
        <stop offset="1" stop-color="#EF3B4B"/>
        </linearGradient>
        <linearGradient id="paint12_linear" x1="362.772" y1="13.9276" x2="128.297" y2="13.9276" gradientUnits="userSpaceOnUse">
        <stop stop-color="#43459C"/>
        <stop offset="0.4083" stop-color="#8F437C"/>
        <stop offset="1" stop-color="#EF3B4B"/>
        </linearGradient>
        <linearGradient id="paint13_linear" x1="514.501" y1="13.9276" x2="-217.531" y2="13.9276" gradientUnits="userSpaceOnUse">
        <stop stop-color="#43459C"/>
        <stop offset="0.4083" stop-color="#8F437C"/>
        <stop offset="1" stop-color="#EF3B4B"/>
        </linearGradient>
        <linearGradient id="paint14_linear" x1="362.773" y1="20.0315" x2="128.299" y2="20.0315" gradientUnits="userSpaceOnUse">
        <stop stop-color="#43459C"/>
        <stop offset="0.4083" stop-color="#8F437C"/>
        <stop offset="1" stop-color="#EF3B4B"/>
        </linearGradient>
        </defs>
      </svg>

      <span class="s-header__version">v.{{version}} from {{buildTime}}</span>
    </div>
    <!-- END: Левая часть хидера -->

    <!-- BEGIN: Правая часть хидера -->
    <div class="s-header__right-part">
      <el-popover
        placement="bottom"
        width="400"
        trigger="click">

        <el-input ref="widget-url" type="text" size="small" v-model="widgetUrl">
          <el-button slot="append" size="small" icon="el-icon-document-copy" @click="handleWidget"></el-button>
        </el-input>
        <p class="s-header__widget-text">Ссылка на виджет</p>

        <el-button slot="reference" size="small" round>Виджет</el-button>
      </el-popover>
      <el-button class="s-header__button-signout" type="primary" size="small" round @click="handleSignOut">Выйти</el-button>
    </div>
    <!-- END: Правая часть хидера -->
  </div>
</template>

<script>
/**
 * Component: Header
 *
 * @version 1.0.0
 */


import { mapGetters, mapActions } from 'vuex';


export default {
  name: 's-header',

  data() {
    return {
      version: process.env.VUE_APP_VERSION,
      buildTime: process.env.VUE_APP_BUILD_TIME,
      widgetUrl: 'https://1x6t7ih2q7.execute-api.eu-west-1.amazonaws.com/dev/public/widget',
    };
  },

  computed: {
    ...mapGetters({
      isLoggin: 'user/isLoggin',
    }),
  },


  methods: {
    async handleWidget() {
      this.$refs['widget-url'].select();
      document.execCommand('copy');
    },
    async handleSignOut() {
      const { error } = await this.signOut();
      if (!error) {
        this.$router.push('/signin');
      } else {
        console.log(error);
        this.$notify({
          title: 'Authentication Error',
          message: error.message,
          duration: 0,
        });
      }
    },

    ...mapActions({
      signOut: 'user/signOut',
    }),
  },
};
</script>

<style lang="scss">
.s-header {
  display: flex;
  text-align: left;
  justify-content: space-between;

  &__left-part {
    display: flex;
  }

  &__logo {
    height: 50px;
    width: 200px;
    margin-top: 5px;
    padding-right: 10px;
  }

  &__text {
    line-height: 60px;
    font-weight: bold;
  }

  &__widget-text {
    font-family: system-ui;
  }

  &__version {
    margin-left: 20px;
  }

  &__highlight {
    padding-left: 20px;
    font-style: italic;
    font-weight: normal;
  }

  &__button-signout {
    margin-left: 15px;
  }
}
</style>
